export default "__VITE_ASSET__Dm3b2dIA__"